import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { getLanguage } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import "./Journey.css";
import courseIconImg from "./assets/home_icons/Home Page_website-12.png";
import gymIconImg from "./assets/home_icons/Home Page_website-13.png";
import testIconImg from "./assets/home_icons/Home Page_website-14.png";
const magazineIconUrl = "https://res.cloudinary.com/dtuy184dc/image/upload/v1775039921/Subscibe_to_Magazine_jkq6ne.png";

const translationData = { en: en, mr: ma };

const Card = ({ icon, title, desc, onClick }) => (
  <div
    className="journey-card"
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyPress={(e) => { if (onClick && (e.key === 'Enter' || e.key === ' ')) onClick(); }}
  >
    <div className="journey-card-inner">
      <div className="journey-icon" aria-hidden>
        {icon}
      </div>
      <h4 className="journey-card-title">{title}</h4>
      <p className="journey-card-desc">{desc}</p>
      <div className="journey-arrow" aria-hidden>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12h14M13 5l7 7-7 7" stroke="#9d0b0e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  </div>
);

const Journey = () => {
  const history = useHistory();
  const [language, setLanguage] = useState(() => getLanguage() || 'en');

  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkLang);
    };
  }, []);

  const courseIcon = <img src={courseIconImg} alt="Attend a course" />;
  const gymIcon = <img src={gymIconImg} alt="Visit mind gym" />;
  const testIcon = <img src={testIconImg} alt="Take online test" />;
  const magazineIcon = <img src={magazineIconUrl} alt="Subscribe to magazine" />;

  return (
    <section className="journey-section">
      <div className="journey-container">
        <p className="journey-subtle">{t('journey_subtle')}</p>
        <h2 className="journey-title">{t('journey_title')}</h2>
        <p className="journey-lead">{t('journey_lead')}</p>

        <div className="journey-grid">
          <Card
            icon={courseIcon}
            title={t('journey_card1_title')}
            desc={t('journey_card1_desc')}
            onClick={() => history.push('/booknow/Residential Study Courses/1')}
          />
          <Card
            icon={gymIcon}
            title={t('journey_card2_title')}
            desc={t('journey_card2_desc')}
            onClick={() => window.open('https://mindgym.manashakti.org/', '_blank')}
          />
          <Card
            icon={testIcon}
            title={t('journey_card3_title')}
            desc={t('journey_card3_desc')}
            onClick={() => window.open('https://onlineselftests.manashakti.org/', '_blank')}
          />
          <Card
            icon={magazineIcon}
            title={t('journey_card4_title')}
            desc={t('journey_card4_desc')}
            onClick={() => window.open('https://www.manashakti.org/magazine-subscription/2', '_blank')}
          />
        </div>
      </div>
    </section>
  );
};

export default Journey;
